// extracted by mini-css-extract-plugin
module.exports = {"ArticleMedia":"ArticleMedia_ArticleMedia__m8_8O","ArticleMedia_caption":"ArticleMedia_ArticleMedia_caption__7RJrf"};